<template>
  <div>
    <v-data-table
      ref="tabelaItens"
      :headers="headersOrdenaveis"
      :items="itens"
      :item-class="obterClasseLinha"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :custom-sort="ordenarItens"
      must-sort
      disable-pagination
      hide-default-footer
      :fixed-header="usaAlturaFixaTabela"
      :height="alturaTabela"
      item-key="uid"
      :class="[
        'c-table-itens-pregao elevation-1',
        { 'c-table-itens-pregao--com-rolagem': usaAlturaFixaTabela && temRolagemTabela }
      ]"
      no-data-text="Nenhum item adicionado. Use o botão Adicionar item."
    >
      <template #item.idGenericaProduto="{ item }">
        <div class="py-1 c-item-meta">
          <div class="c-item-meta__numero">Item {{ item.idGenericaProduto }}</div>
          <div class="c-item-meta__descricao">{{ item.descricao_edital || "Sem descrição informada" }}</div>
          <v-chip
            v-if="item.bloqueadoEdicao"
            x-small
            class="mt-1"
            color="#943634"
            text-color="white"
          >
            Empenhado
          </v-chip>
        </div>
      </template>

      <template #item.produto="{ item }">
        <div class="d-flex align-center py-1">
          <img
            :src="item.imageUrl"
            width="40"
            height="40"
            class="rounded mr-2"
            style="object-fit: cover;"
          />
          <span class="c-item-produto-nome">{{ item.name }}</span>
        </div>
      </template>

      <template #item.quantidadeProdutoPregao="{ item }">
        <div class="c-cell-readonly c-cell-readonly--numeric c-field-quantidade">
          {{ formatarQuantidade(item.quantidadeProdutoPregao) }}
        </div>
      </template>

      <template #item.valorProdutoPregao="{ item }">
        <div class="c-cell-readonly c-cell-readonly--numeric c-field-venda">
          {{ item.valorProdutoPregao | dinheiro }}
        </div>
      </template>

      <template #item.valorTotal="{ item }">
        <div class="c-cell-readonly c-cell-readonly--numeric c-field-total">
          {{ valorTotalItem(item) | dinheiro }}
        </div>
      </template>

      <template #item.valorDeCompra="{ item }">
        <div class="c-cell-readonly c-cell-readonly--numeric c-field-compra">
          {{ item.valorDeCompra | dinheiro }}
        </div>
      </template>

      <template #item.tipoUnidade="{ item }">
        <div class="c-cell-readonly c-field-unidade">
          {{ obterRotuloUnidade(item.tipoUnidade) || "-" }}
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex align-center">
          <v-tooltip top color="#943634">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                type="button"
                icon
                :color="itemEstaSendoEditado(item) ? '#943634' : 'primary'"
                small
                v-bind="attrs"
                v-on="on"
                @click="abrirModalEdicao(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            {{
              item.bloqueadoEdicao
                ? "Clique para editar somente o valor de compra deste item empenhado."
                : "Clique para editar o item de pregão."
            }}
          </v-tooltip>

          <template v-if="item.bloqueadoEdicao">
            <v-tooltip top color="#943634">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn type="button" icon color="#943634" small disabled>
                    <v-icon small>mdi-lock</v-icon>
                  </v-btn>
                </span>
              </template>
              Itens de pregão com empenhos não podem ser excluídos.
            </v-tooltip>
          </template>
          <v-btn
            v-else
            type="button"
            icon
            color="error"
            small
            @click="confirmarRemocao(item)"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:body.append>
        <tr :class="['c-itens-total-row', { 'c-itens-total-row--fixo': usaAlturaFixaTabela }]">
          <td colspan="4" class="text-right font-weight-bold">TOTAL DO PREGÃO:</td>
          <td class="font-weight-bold text-right">{{ totalPregao | dinheiro }}</td>
          <td colspan="3"></td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogItem" max-width="980px" persistent scrollable>
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>{{ tituloModalItem }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="fecharModalItem">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="itemModal.numero_item"
                outlined
                dense
                type="tel"
                label="Nº do Item"
                autocomplete="off"
                inputmode="numeric"
                pattern="[0-9]*"
                :disabled="campoModalBloqueado('numero_item')"
                :class="{ 'c-modal-field--locked': campoModalBloqueado('numero_item') }"
                @input="tratarInputNumeroItem"
                @keydown.native="bloquearEntradaNaoNumerica"
                @paste.native.prevent="tratarColagemNumeroItem"
                @drop.native.prevent
              />
            </v-col>

            <v-col cols="12" md="9">
              <v-text-field
                v-model="itemModal.descricao_edital"
                outlined
                dense
                label="Descrição / Objeto"
                :disabled="campoModalBloqueado('descricao_edital')"
                :class="{ 'c-modal-field--locked': campoModalBloqueado('descricao_edital') }"
              />
            </v-col>

            <v-col cols="12" md="8">
              <v-autocomplete
                v-model="itemModal.produto"
                :items="produtosCadastrados"
                item-text="name"
                item-value="id"
                return-object
                outlined
                dense
                label="Produto"
                clearable
                :disabled="campoModalBloqueado('produto')"
                :class="{ 'c-modal-field--locked': campoModalBloqueado('produto') }"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-avatar size="36">
                    <img :src="item.imageUrl" style="object-fit: cover;" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="itemModal.tipoUnidade"
                :items="tiposUnidadeOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
                label="Unidade"
                :disabled="campoModalBloqueado('tipoUnidade')"
                :class="{ 'c-modal-field--locked': campoModalBloqueado('tipoUnidade') }"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="itemModal.quantidadeProdutoPregao"
                outlined
                dense
                type="number"
                min="0"
                label="Quantidade"
                :disabled="campoModalBloqueado('quantidadeProdutoPregao')"
                :class="{ 'c-modal-field--locked': campoModalBloqueado('quantidadeProdutoPregao') }"
                @change="normalizarNumeroModal('quantidadeProdutoPregao')"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-currency-field
                v-model="itemModal.valorProdutoPregao"
                outlined
                dense
                prefix="R$"
                label="Vl. Venda"
                :disabled="campoModalBloqueado('valorProdutoPregao')"
                :class="{ 'c-modal-field--locked': campoModalBloqueado('valorProdutoPregao') }"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-currency-field
                v-model="itemModal.valorDeCompra"
                outlined
                dense
                prefix="R$"
                label="Vl. Compra"
                :disabled="campoModalBloqueado('valorDeCompra')"
                :class="{ 'c-modal-field--locked': campoModalBloqueado('valorDeCompra') }"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                outlined
                dense
                readonly
                label="Vl. Total"
                class="c-modal-field--readonly"
                :value="$options.filters.dinheiro(valorTotalModal)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn type="button" text @click="fecharModalItem">Cancelar</v-btn>
          <v-btn type="button" color="#943634" dark @click="salvarItemModal">
            <v-icon left>mdi-content-save</v-icon>
            {{ textoBotaoSalvarItem }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRemover" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">Remover item?</v-card-title>
        <v-card-text>
          O item "<strong>{{ itemParaRemover && itemParaRemover.name }}</strong>" será removido da licitação.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn type="button" text @click="dialogRemover = false">Cancelar</v-btn>
          <v-btn type="button" color="error" text @click="removerItem">Remover</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { showError } from "@/global";
import {
  carregarTiposUnidade,
  listarTiposUnidadeOptions,
  obterRotuloTipoUnidade as obterRotuloTipoUnidadeHelper,
} from "@/utils/tiposUnidade";

const novoItemPadrao = () => ({
  uid: null,
  id: null,
  numero_item: "",
  descricao_edital: "",
  produto: null,
  quantidadeProdutoPregao: 0,
  valorProdutoPregao: 0,
  valorDeCompra: 0,
  tipoUnidade: null,
  bloqueadoEdicao: false,
  quantidade_empenhada: 0,
  quantidade_restante: 0,
});

export default {
  name: "itensPregao",
  props: {
    produtosCadastrados: { type: Array, default: () => [] },
    itensIniciais: { type: Array, default: () => [] },
    modoEdicao: { type: Boolean, default: false },
  },
  data() {
    return {
      itens: [],
      dialogItem: false,
      dialogRemover: false,
      itemParaRemover: null,
      itemModal: novoItemPadrao(),
      itemModalUid: null,
      modalEdicaoRestrita: false,
      temRolagemTabela: false,
      alturaViewport: typeof window !== "undefined" ? window.innerHeight : 900,
      alturaConteudoTabela: null,
      sortBy: "idGenericaProduto",
      sortDesc: false,
      headers: [
        { text: "N° / Descrição", value: "idGenericaProduto", sortable: false, width: "280px", align: "start" },
        { text: "Produto", value: "produto", sortable: false, align: "start" },
        { text: "Qtd.", value: "quantidadeProdutoPregao", sortable: false, width: "90px", align: "end" },
        { text: "Vl. Venda", value: "valorProdutoPregao", sortable: false, width: "120px", align: "end" },
        { text: "Vl. Total", value: "valorTotal", sortable: false, width: "140px", align: "end" },
        { text: "Vl. Compra", value: "valorDeCompra", sortable: false, width: "120px", align: "end" },
        { text: "Unidade", value: "tipoUnidade", sortable: false, width: "110px", align: "start" },
        { text: "Ação", value: "actions", sortable: false, width: "72px", align: "center" },
      ],
      tiposUnidadeOptions: listarTiposUnidadeOptions(),
    };
  },
  computed: {
    totalPregao() {
      return this.itens.reduce((acc, item) => acc + this.valorTotalItem(item), 0);
    },
    headersOrdenaveis() {
      return this.headers.map((header) => ({
        ...header,
        sortable: header.value !== "actions",
      }));
    },
    tituloModalItem() {
      if (!this.itemModalUid) return "Adicionar Item de Pregão";
      if (this.modalEdicaoRestrita) return "Editar Item Empenhado";
      return "Editar Item de Pregão";
    },
    textoBotaoSalvarItem() {
      return this.itemModalUid ? "Salvar item" : "Adicionar item";
    },
    valorTotalModal() {
      const quantidade = Number(this.itemModal.quantidadeProdutoPregao) || 0;
      const valorVenda = Number(this.itemModal.valorProdutoPregao) || 0;
      return quantidade * valorVenda;
    },
    alturaMaximaTabela() {
      return Math.max(320, Math.round((this.alturaViewport || 900) * 0.55));
    },
    alturaNecessariaTabela() {
      if (this.alturaConteudoTabela) {
        return this.alturaConteudoTabela;
      }

      const alturaCabecalho = 56;
      const alturaLinha = 72;
      const alturaRodape = 58;
      const quantidadeLinhas = this.itens.length || 1;
      return alturaCabecalho + alturaRodape + quantidadeLinhas * alturaLinha;
    },
    usaAlturaFixaTabela() {
      return this.alturaNecessariaTabela > this.alturaMaximaTabela;
    },
    alturaTabela() {
      return this.usaAlturaFixaTabela ? `${this.alturaMaximaTabela}px` : undefined;
    },
  },
  watch: {
    itens: {
      deep: true,
      handler() {
        this.emitirAlteracoes();
        this.$nextTick(() => this.atualizarIndicadorRolagem());
      },
    },
    itensIniciais: {
      immediate: true,
      handler(itens) {
        try {
          this.itens = (itens || []).map((item) => this.normalizarItem(item));
        } catch (err) {
          this.itens = [];
          showError(err);
          return;
        }

        if (this.itemModalUid && !this.itens.find((item) => item.uid === this.itemModalUid)) {
          this.fecharModalItem();
        }

        this.$nextTick(() => this.atualizarIndicadorRolagem());
      },
    },
    sortBy() {
      this.$nextTick(() => this.atualizarIndicadorRolagem());
    },
    sortDesc() {
      this.$nextTick(() => this.atualizarIndicadorRolagem());
    },
    dialogItem() {
      this.$nextTick(() => this.atualizarIndicadorRolagem());
    },
  },
  methods: {
    async carregarTiposUnidadeOptions() {
      try {
        await carregarTiposUnidade();
        this.tiposUnidadeOptions = listarTiposUnidadeOptions();
      } catch (err) {
        this.tiposUnidadeOptions = [];
        showError(err);
      }
    },

    sanitizarNumeroItemEntrada(valor) {
      return String(valor || "").replace(/\D/g, "");
    },

    normalizarNumeroItemInteiro(valor) {
      if (valor === null || valor === undefined || valor === "") return "";

      const numero = Number.parseInt(String(valor).trim(), 10);
      return Number.isInteger(numero) && numero >= 0 ? String(numero) : "";
    },

    tratarInputNumeroItem(valor) {
      this.itemModal.numero_item = this.sanitizarNumeroItemEntrada(valor);
    },

    bloquearEntradaNaoNumerica(event) {
      if (event.ctrlKey || event.metaKey || event.altKey) return;

      const teclasLiberadas = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];

      if (teclasLiberadas.includes(event.key)) return;
      if (/^\d$/.test(event.key)) return;

      event.preventDefault();
    },

    tratarColagemNumeroItem(event) {
      const textoColado = this.sanitizarNumeroItemEntrada(
        (event.clipboardData || window.clipboardData).getData("text")
      );
      const alvo = event.target;
      const valorAtual = String(this.itemModal.numero_item || "");
      const inicio = alvo.selectionStart || 0;
      const fim = alvo.selectionEnd || 0;

      this.itemModal.numero_item = `${valorAtual.slice(0, inicio)}${textoColado}${valorAtual.slice(fim)}`;
    },

    formatarQuantidade(valor) {
      const numero = Number(valor) || 0;

      return numero.toLocaleString("pt-BR", {
        minimumFractionDigits: Number.isInteger(numero) ? 0 : 2,
        maximumFractionDigits: 4,
      });
    },

    normalizarNumeroModal(campo) {
      const valorNumerico = Number(this.itemModal[campo]) || 0;
      this.itemModal[campo] = valorNumerico < 0 ? 0 : valorNumerico;
    },

    obterRotuloUnidade(tipoUnidade) {
      return obterRotuloTipoUnidadeHelper(tipoUnidade, "");
    },

    obterValorOrdenacao(item, campo) {
      switch (campo) {
        case "idGenericaProduto":
          return `${item.idGenericaProduto || ""} ${item.descricao_edital || ""}`.trim();
        case "produto":
          return item.name || "";
        case "valorTotal":
          return this.valorTotalItem(item);
        case "tipoUnidade":
          return this.obterRotuloUnidade(item.tipoUnidade);
        default:
          return item[campo];
      }
    },

    compararValoresOrdenacao(valorA, valorB) {
      const numeroA = Number(valorA);
      const numeroB = Number(valorB);
      const ambosNumericos = !Number.isNaN(numeroA) && !Number.isNaN(numeroB);

      if (ambosNumericos) {
        return numeroA - numeroB;
      }

      return String(valorA || "").localeCompare(String(valorB || ""), "pt-BR", {
        numeric: true,
        sensitivity: "base",
      });
    },

    ordenarItens(items, sortBy, sortDesc) {
      const campos = Array.isArray(sortBy) ? sortBy : [sortBy];
      const direcoes = Array.isArray(sortDesc) ? sortDesc : [sortDesc];
      const campoAtual = campos[0] || "idGenericaProduto";
      const descendente = !!direcoes[0];
      const itensOrdenados = [...items];

      return itensOrdenados.sort((itemA, itemB) => {
        const comparacaoPrincipal = this.compararValoresOrdenacao(
          this.obterValorOrdenacao(itemA, campoAtual),
          this.obterValorOrdenacao(itemB, campoAtual)
        );

        if (comparacaoPrincipal !== 0) {
          return descendente ? -comparacaoPrincipal : comparacaoPrincipal;
        }

        const comparacaoSecundaria = this.compararValoresOrdenacao(
          this.obterValorOrdenacao(itemA, "idGenericaProduto"),
          this.obterValorOrdenacao(itemB, "idGenericaProduto")
        );

        return descendente ? -comparacaoSecundaria : comparacaoSecundaria;
      });
    },

    normalizarItem(item) {
      return {
        uid: item.uid || `item-${item.id || Date.now()}-${Math.random()}`,
        id: item.id || null,
        produto_id: Number(item.produto_id || (item.produto && item.produto.id)) || null,
        name: item.name || (item.produto && item.produto.name) || "",
        imageUrl: item.imageUrl || (item.produto && item.produto.imageUrl) || "",
        idGenericaProduto: String(item.idGenericaProduto || item.numero_item || ""),
        descricao_edital: item.descricao_edital || "",
        quantidadeProdutoPregao: Number(
          item.quantidadeProdutoPregao !== undefined ? item.quantidadeProdutoPregao : item.quantidade
        ) || 0,
        valorProdutoPregao: Number(
          item.valorProdutoPregao !== undefined ? item.valorProdutoPregao : item.valor_unitario_venda
        ) || 0,
        valorDeCompra: Number(
          item.valorDeCompra !== undefined ? item.valorDeCompra : item.valor_unitario_compra
        ) || 0,
        tipoUnidade: item.tipoUnidade !== undefined ? item.tipoUnidade : item.tipo_unidade,
        bloqueadoEdicao: !!item.bloqueadoEdicao,
        quantidade_empenhada: Number(item.quantidade_empenhada || item.quantidades_empenhadas) || 0,
        quantidade_restante: Number(item.quantidade_restante) || 0,
      };
    },

    resolverProdutoSelecionado(item) {
      return (
        this.produtosCadastrados.find((produto) => produto.id === item.produto_id) || {
          id: item.produto_id,
          name: item.name,
          imageUrl: item.imageUrl,
        }
      );
    },

    abrirModalNovoItem() {
      this.itemModalUid = null;
      this.modalEdicaoRestrita = false;
      this.itemModal = novoItemPadrao();
      if (this.tiposUnidadeOptions.length) {
        this.itemModal.tipoUnidade = this.tiposUnidadeOptions[0].value;
      }
      this.dialogItem = true;
    },

    abrirModalEdicao(item) {
      const itemNormalizado = this.normalizarItem(item);

      this.itemModalUid = itemNormalizado.uid;
      this.modalEdicaoRestrita = itemNormalizado.bloqueadoEdicao;
      this.itemModal = {
        uid: itemNormalizado.uid,
        id: itemNormalizado.id,
        numero_item: this.normalizarNumeroItemInteiro(itemNormalizado.idGenericaProduto),
        descricao_edital: itemNormalizado.descricao_edital || "",
        produto: this.resolverProdutoSelecionado(itemNormalizado),
        quantidadeProdutoPregao: itemNormalizado.quantidadeProdutoPregao,
        valorProdutoPregao: itemNormalizado.valorProdutoPregao,
        valorDeCompra: itemNormalizado.valorDeCompra,
        tipoUnidade: itemNormalizado.tipoUnidade,
        bloqueadoEdicao: itemNormalizado.bloqueadoEdicao,
        quantidade_empenhada: itemNormalizado.quantidade_empenhada,
        quantidade_restante: itemNormalizado.quantidade_restante,
      };
      this.dialogItem = true;
    },

    fecharModalItem() {
      this.dialogItem = false;
      this.itemModalUid = null;
      this.modalEdicaoRestrita = false;
      this.itemModal = novoItemPadrao();
    },

    campoModalBloqueado(campo) {
      if (!this.itemModalUid) return false;
      if (!this.modalEdicaoRestrita) return false;

      return campo !== "valorDeCompra";
    },

    validarItemModal() {
      if (!this.itemModalUid || !this.modalEdicaoRestrita) {
        if (!this.itemModal.produto) {
          showError("Selecione um produto para associar ao item.");
          return false;
        }

        if (!this.itemModal.numero_item) {
          showError("Informe o número do item conforme edital.");
          return false;
        }

        if (!Number(this.itemModal.quantidadeProdutoPregao) || Number(this.itemModal.quantidadeProdutoPregao) <= 0) {
          showError("Informe uma quantidade válida para o item.");
          return false;
        }

        if (!Number(this.itemModal.valorProdutoPregao) || Number(this.itemModal.valorProdutoPregao) <= 0) {
          showError("Informe um valor de venda válido para o item.");
          return false;
        }

      }

      return true;
    },

    salvarItemModal() {
      if (!this.validarItemModal()) {
        return;
      }

      const itemAtual = this.itemModalUid
        ? this.itens.find((item) => item.uid === this.itemModalUid)
        : null;

      let itemNormalizado = null;

      try {
        itemNormalizado = this.normalizarItem({
          ...(itemAtual || {}),
          id: itemAtual ? itemAtual.id : null,
          uid: itemAtual ? itemAtual.uid : null,
          produto_id: this.itemModal.produto ? this.itemModal.produto.id : itemAtual && itemAtual.produto_id,
          name: this.itemModal.produto ? this.itemModal.produto.name : itemAtual && itemAtual.name,
          imageUrl: this.itemModal.produto ? this.itemModal.produto.imageUrl : itemAtual && itemAtual.imageUrl,
          idGenericaProduto: this.itemModalUid && this.modalEdicaoRestrita
            ? itemAtual.idGenericaProduto
            : this.normalizarNumeroItemInteiro(this.itemModal.numero_item),
          descricao_edital: this.itemModal.descricao_edital || "",
          quantidadeProdutoPregao: Number(this.itemModal.quantidadeProdutoPregao) || 0,
          valorProdutoPregao: Number(this.itemModal.valorProdutoPregao) || 0,
          valorDeCompra: Number(this.itemModal.valorDeCompra) || 0,
          tipoUnidade: this.itemModal.tipoUnidade,
          bloqueadoEdicao: !!(itemAtual && itemAtual.bloqueadoEdicao),
          quantidade_empenhada: itemAtual ? itemAtual.quantidade_empenhada : 0,
          quantidade_restante: itemAtual ? itemAtual.quantidade_restante : 0,
        });
      } catch (err) {
        showError(err);
        return;
      }

      if (itemAtual) {
        const indice = this.itens.findIndex((item) => item.uid === this.itemModalUid);
        this.$set(this.itens, indice, itemNormalizado);
      } else {
        this.itens.push(itemNormalizado);
      }

      this.fecharModalItem();
    },

    confirmarRemocao(item) {
      if (item.bloqueadoEdicao) return;
      this.itemParaRemover = item;
      this.dialogRemover = true;
    },

    removerItem() {
      this.itens = this.itens.filter((item) => item.uid !== this.itemParaRemover.uid);

      if (this.itemModalUid === this.itemParaRemover.uid) {
        this.fecharModalItem();
      }

      this.itemParaRemover = null;
      this.dialogRemover = false;
    },

    valorTotalItem(item) {
      const quantidade = Number(item.quantidadeProdutoPregao) || 0;
      const valorVenda = Number(item.valorProdutoPregao) || 0;
      return quantidade * valorVenda;
    },

    itemEstaSendoEditado(item) {
      return !!item && !!this.itemModalUid && item.uid === this.itemModalUid;
    },

    obterClasseLinha(item) {
      if (!item) return "";

      const classes = [];

      if (item.bloqueadoEdicao) {
        classes.push("c-item-bloqueado");
      }

      if (this.itemEstaSendoEditado(item)) {
        classes.push("c-item-editando");
      }

      return classes.join(" ");
    },

    atualizarIndicadorRolagem() {
      this.alturaViewport = typeof window !== "undefined" ? window.innerHeight : 900;

      const tabela = this.$refs.tabelaItens;
      const wrapper = tabela && tabela.$el ? tabela.$el.querySelector(".v-data-table__wrapper") : null;

      this.alturaConteudoTabela = wrapper ? wrapper.scrollHeight : null;
      this.temRolagemTabela = !!wrapper && wrapper.scrollHeight > wrapper.clientHeight + 4;
    },

    emitirAlteracoes() {
      this.$emit(
        "change",
        this.itens.map((item) => ({
          ...item,
          quantidadeProdutoPregao: Number(item.quantidadeProdutoPregao) || 0,
          valorProdutoPregao: Number(item.valorProdutoPregao) || 0,
          valorDeCompra: Number(item.valorDeCompra) || 0,
          valorTotal: this.valorTotalItem(item),
        }))
      );
    },
  },
  mounted() {
    window.addEventListener("resize", this.atualizarIndicadorRolagem);
    this.carregarTiposUnidadeOptions();
    this.$nextTick(() => this.atualizarIndicadorRolagem());
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.atualizarIndicadorRolagem);
  },
};
</script>

<style>
.c-field-quantidade,
.c-field-venda,
.c-field-compra,
.c-field-total,
.c-field-unidade {
  width: 100%;
}

.c-item-meta {
  min-width: 220px;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.35;
}

.c-item-meta__numero,
.c-item-meta__descricao {
  font-size: inherit;
  font-weight: 400;
  line-height: inherit;
  color: inherit;
}

.c-item-produto-nome {
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.35;
  color: #555;
}

.c-cell-readonly {
  min-height: 36px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #555;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.35;
}

.c-cell-readonly--numeric {
  justify-content: flex-end;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.c-table-itens-pregao .v-data-table__wrapper {
  overflow-y: auto;
  border: 2px solid #dddddd;
  border-radius: 10px;
  box-shadow: inset 0 14px 18px -18px rgba(0, 0, 0, 0.4);
  scrollbar-width: auto;
  scrollbar-color: #9f9f9f #efefef;
}

.c-table-itens-pregao--com-rolagem .v-data-table__wrapper {
  box-shadow:
    inset 0 18px 18px -18px rgba(0, 0, 0, 0.45),
    inset 0 -24px 22px -20px rgba(0, 0, 0, 0.5);
}

.c-table-itens-pregao .v-data-table__wrapper::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}

.c-table-itens-pregao .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #efefef;
  border-left: 1px solid #d8d8d8;
}

.c-table-itens-pregao .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #9f9f9f;
  border: 3px solid #efefef;
  border-radius: 999px;
}

.c-table-itens-pregao thead th {
  background: #fff;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06);
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: #5c5c5c !important;
  white-space: nowrap;
}

.c-table-itens-pregao--com-rolagem thead th {
  position: sticky;
  top: 0;
  z-index: 3;
}

.c-table-itens-pregao tbody td {
  font-size: 0.95rem;
  color: #555;
  vertical-align: middle;
}

.c-table-itens-pregao .c-item-bloqueado {
  background: #efefef !important;
}

.c-table-itens-pregao .c-item-bloqueado td,
.c-table-itens-pregao .c-item-bloqueado .c-item-meta,
.c-table-itens-pregao .c-item-bloqueado .c-cell-readonly,
.c-table-itens-pregao .c-item-bloqueado .c-item-produto-nome {
  color: #666 !important;
}

.c-table-itens-pregao tbody tr:not(.c-item-bloqueado):not(.c-item-editando) {
  background: #fcfcfc;
}

.c-table-itens-pregao tbody tr:hover:not(.c-item-bloqueado):not(.c-item-editando) {
  background: #faf7f2 !important;
}

.c-table-itens-pregao tbody tr.c-item-bloqueado:hover {
  background: #e7e7e7 !important;
}

.c-table-itens-pregao .c-item-editando {
  background: #fff7e8 !important;
}

.c-itens-total-row--fixo {
  position: sticky;
  bottom: 0;
  z-index: 2;
}

.c-itens-total-row td {
  font-size: 1rem !important;
  background: #f5f5f5;
  border-top: 2px solid #943634 !important;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.08);
}

.c-modal-field--locked .v-input__slot,
.c-modal-field--readonly .v-input__slot {
  background: #f5f5f5 !important;
}
</style>
